import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';
import Iframe from 'react-iframe'
import './Multivar.css';

class Mds extends React.PureComponent {

  state = {
    selectedTabId:'widget'
  }


  handleTabChange = (navbarTabId) => this.setState({ selectedTabId: navbarTabId });

  render() {
    const { plotUrl, distMatUrl, t } = this.props;
    const plot= <Iframe className='iframe' url={plotUrl} />;
    const distMat=  <Iframe className='iframe' url={distMatUrl} />

    return (
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
          {plotUrl && <Tab id='plot' title={t('chart')} panel={plot} />}
          {distMatUrl && <Tab id='distMat' title={t('distMat')} panel={distMat} />}
        </Tabs>
    );
  }
}

Mds.propTypes = {
    plotUrl: PropTypes.string,
    distMatUrl: PropTypes.string,
};

export default withTranslation()(Mds);
